import react from "react";
import '../css/Common.css'
const FAQ = () => {
    return (
        <div className="page-container">
            <h1>FAQ</h1>
            <h3>1. What is this platform?</h3>
            <p>This platform allows users to report city issues and view services.</p>
            <h3>2. How can I report an issue?</h3>
            <p>Go to Report Issue page and submit your complaint.</p>
            <h3>3. Is login required?</h3>
            <p>Yes, you must login to report or track issues.</p>
        </div>
    );
};
export default FAQ;